import bus from '@/services/evbus';
import router from '@/routes';
import store from '@/store';
import { cloneDeep } from 'lodash';
import ColumnsService from '@/services/columns';
import { VNode } from 'vue/types/umd';

export default {
  install (Vue: any, settings: any) {
    let vnode: VNode = null;
    Vue.directive('table-preloader', {
      bind(el: any, binding: any, vnode: VNode) {
        // el.addEventListener('click', (ev: any) => {
        //   if(ev.which === 1) { //right click
        //     const value = cloneDeep(vnode.data.attrs.link);

        //     console.log('value', value);
        //     console.log('vnode', vnode);

        //     if(!value) {
        //       return;
        //     }



        //     const currentType = ColumnsService.type;
        //     const nextType = ColumnsService.getType(value);

        //     if(currentType === nextType) {
        //       return;
        //     }

        //     store.commit('loading', true);
        //     store.commit('tableMenuOverride', nextType);

        //     bus.emit('freeze-table');

        //     setTimeout(() => {
        //       router.push(value);

        //       setTimeout(() => {
        //         Vue.nextTick(() => {
        //           bus.emit('get-report');
        //         });
        //       }, 10);
        //     });
        //   }
        // });
      },
      // update(el: any, binding: any, _vnode: VNode) {
      //   console.log({ el, binding, _vnode });
      // }
    })
  }
}